export function PriceCheckIcon(){
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <mask id="mask0_4894_82809" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9"/>
      </mask>
      <g mask="url(#mask0_4894_82809)">
        <path d="M6.5 14.975V13.975H4V11.975H9V9.97501H5C4.71667 9.97501 4.47917 9.87917 4.2875 9.68751C4.09583 9.49584 4 9.25834 4 8.97501V4.97501C4 4.69167 4.09583 4.45417 4.2875 4.26251C4.47917 4.07084 4.71667 3.97501 5 3.97501H6.5V2.97501H8.5V3.97501H11V5.97501H6V7.97501H10C10.2833 7.97501 10.5208 8.07084 10.7125 8.26251C10.9042 8.45417 11 8.69167 11 8.97501V12.975C11 13.2583 10.9042 13.4958 10.7125 13.6875C10.5208 13.8792 10.2833 13.975 10 13.975H8.5V14.975H6.5ZM13.95 20.975L9.7 16.725L11.1 15.325L13.95 18.175L19.6 12.525L21 13.925L13.95 20.975Z" fill="#8BE68A"/>
      </g>
    </svg>
  )
}